import { hydrateRoot } from 'react-dom/client';
import { type FC } from 'react';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay';
import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { ServerVarsContextProvider } from '../sharedComponents/ServerVarsContext.tsx';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import serverVars from 'server-vars';
import * as tracking from 'dibs-tracking';
import { QuestionLayout } from '../questionsAnswers/question/questionLayout.tsx';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { questionRootQuery } from '../questionsAnswers/questionRootQuery.ts';
import { type questionRootQuery as questionRootQueryType } from '../questionsAnswers/__generated__/questionRootQuery.graphql.ts';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const variables = serverVars.get('relayVariables');

const ComponentWrapper: FC = () => {
    const data = useLazyLoadQuery<questionRootQueryType>(questionRootQuery, variables, {
        fetchPolicy: 'store-only',
    });

    return <QuestionLayout viewer={data.viewer} />;
};

initializeDBL().then(({ store }: { store: Store }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <Provider store={store}>
            <IntlProvider locale={serverVars.get('locale')} disableTranslations>
                <ServerVarsContextProvider
                    isMobile={serverVars.get('settings.isMobile')}
                    isTablet={serverVars.get('settings.isTablet')}
                    isDesktop={serverVars.get('settings.isDesktop')}
                >
                    <RelayEnvironmentProvider environment={environment}>
                        <ComponentWrapper />
                    </RelayEnvironmentProvider>
                </ServerVarsContextProvider>
            </IntlProvider>
        </Provider>
    );
    tracking.trackPageview({
        additional: {
            pageType: 'Content',
            pageSubType: 'Answers',
        },
    });
});
